import * as PIXI from 'pixi.js'
// import { OutlineFilter as FilterOutline } from '@pixi/filter-outline'
import { CRTFilter as FilterCRT } from '@pixi/filter-crt'
import { RGBSplitFilter as FilterRGBSplit } from '@pixi/filter-rgb-split'
import TWEEN from '@tweenjs/tween.js'
import { lerp } from './utils'

PIXI.utils.skipHello()

class RenderSystem {
  constructor (game, el) {
    this.game = game
    this.el = el
    this.pixiUpdate = this.pixiUpdate.bind(this)
    const rect = this.el.getBoundingClientRect()
    if (this.pixiApp) {
      this.pixiApp.destroy({ children: true, texture: true, baseTexture: true })
    }
    this.pixiApp = new PIXI.Application(rect.width, rect.height, {
      antialias: true,
      transparent: true
    })
    // Create objects // initObjects
    this.resetStage()
    // Create
    // Prepare some filteters
    //

    this.el.appendChild(this.pixiApp.view)
    this.resize()
  }
  // Update container size
  resize () {
    const rect = this.el.getBoundingClientRect()
    if (this.rect && (rect.width === this.rect.width && rect.height === this.rect.height)) {
      return
    }
    this.pixiApp.renderer.resize(rect.width, rect.height)

    // Recreate BG on resize
    if (this.pixi.tilebg) {
      this.pixi.tilebg.width = this.pixiApp.screen.width
      this.pixi.tilebg.height = this.pixiApp.screen.height
    }
    // Pivot set
    this.pixi.stage.pivot.set(-this.pixiApp.renderer.width / 2, -this.pixiApp.renderer.height / 2)
    this.rect = rect
  }
  // resetStage
  resetStage () {
    TWEEN.removeAll()
    this.pixiApp.ticker.remove(this.pixiUpdate)
    PIXI.utils.clearTextureCache()

    this.pixi = {}
    this.pixi.filters = {
      default: [
        new FilterRGBSplit(
          new PIXI.Point(-0.8, -0.8),
          new PIXI.Point(0, 0),
          new PIXI.Point(0.9, 0.5)
        )
      ],
      dead: [
        new FilterCRT({
          curvature: 10,
          lineWidth: 5,
          lineContrast: 0.2,
          vignetting: 0
        }),
        new FilterRGBSplit(
          new PIXI.Point(-2, 0),
          new PIXI.Point(1, 2),
          new PIXI.Point(2, 1)
        )
      ]
    }

    // XXX: ADD FILTER BACK
    this.pixiApp.stage.filters = this.pixi.filters.dead
    this.pixiApp.stage.removeChildren().forEach(r => r.destroy({ children: true, texture: true, baseTexture: true }))

    // Parent of whole
    const bgSprite = PIXI.Texture.fromImage(this.game.config.background)
    this.pixi.tilebg = new PIXI.extras.TilingSprite(
      bgSprite,
      this.pixiApp.screen.width,
      this.pixiApp.screen.height
    )
    this.pixiApp.stage.addChild(this.pixi.tilebg)

    this.pixi.stage = new PIXI.Container()
    this.pixi.stage.pivot.set(-this.pixiApp.renderer.width / 2, -this.pixiApp.renderer.height / 2)
    this.pixiApp.stage.addChild(this.pixi.stage)
    // Create world stage
    // camera
    this.pixi.worldMap = new PIXI.Container()
    this.pixi.stage.addChild(this.pixi.worldMap)
    { // eslint-disable-line
      this.pixi.linkMap = new PIXI.Graphics()
      this.pixi.players = new PIXI.Container()
      this.pixi.playerPos = new PIXI.Graphics()
      this.pixi.nodes = new PIXI.Container()
      this.pixi.text = new PIXI.Container()
      this.pixi.effects = new PIXI.Container()

      this.pixi.worldMap.addChild(this.pixi.linkMap)
      this.pixi.worldMap.addChild(this.pixi.nodes)
      this.pixi.worldMap.addChild(this.pixi.players)
      this.pixi.worldMap.addChild(this.pixi.playerPos)
      this.pixi.worldMap.addChild(this.pixi.text)
      this.pixi.worldMap.addChild(this.pixi.effects)

      // BLUR + threshold
    }

    // Player tracking
    this.pixi.tracking = {}
    this.pixi.tracking.nodes = new PIXI.Graphics()
    this.pixi.tracking.nodes.alpha = 0.7
    this.pixiApp.stage.addChild(this.pixi.tracking.nodes)

    this.pixi.tracking.player = new PIXI.Container()
    this.pixi.tracking.player.alpha = 0.7
    this.pixiApp.stage.addChild(this.pixi.tracking.player)
    // Create necessary things and hide
    for (let i = 2; i >= 0; i--) {
      const track = new PIXI.Container()

      const gr = new PIXI.Graphics()
      track.addChild(gr)

      const text = new PIXI.Text(3 - i)
      text.anchor.set(0.5, 0.5)
      track.addChild(text)

      track.visible = false

      this.pixi.tracking.player.addChild(track)
    }

    // find better place for this
    const s = window.localStorage.getItem('player.scale') || 1
    this.pixi.worldMap.scale.set(s)

    this.pixiApp.ticker.add(this.pixiUpdate)
    // this.refreshChunk()
    // Tween animation
  }
  wordClaim (wordClaim) {
    const pixiWord = new PIXI.Text(wordClaim.word, { fontSize: 40, fill: 'pink', stroke: 'black' })
    pixiWord.x = this.pixiApp.screen.width - 100
    pixiWord.y = this.pixiApp.screen.height - pixiWord.height - 50
    pixiWord.anchor.set(1, 0.5)
    this.pixiApp.stage.addChild(pixiWord)

    const anim = { alpha: 1, zoom: 1 }
    new TWEEN.Tween(anim)
      .to({ alpha: 0, zoom: 2 }, 3000)
      .onUpdate(() => {
        pixiWord.alpha = anim.alpha
        pixiWord.scale.set(anim.zoom)
      })
      .onComplete(() => {
        pixiWord.destroy({ children: true, texture: true })
      }).start()
  }
  width () {
    return this.pixiApp.screen.width
  }
  height () {
    return this.pixiApp.screen.height
  }
  // pixiUpdate loop or Gameloop whatever
  pixiUpdate (delta) {
    this.resize() // checkResize and do resize
    TWEEN.update()
    this.game.players.playerRender(delta)
    this.game.nodes.nodeRender(delta)

    if (this.game.playing === 3) {
      const filterCRT = this.pixi.filters.dead[0]
      if (filterCRT.vignetting < 0.5) filterCRT.vignetting += 0.0015
      filterCRT.time = (filterCRT.time + 1) % 20
    }

    const player = this.game.players.playerGet(this.game.follow)
    if (!player) {
      return
    }
    // CAMERA
    this.pixi.worldMap.pivot.set(
      lerp(
        this.pixi.worldMap.pivot.x, player.pixiObj.x,
        this.game.config.lerpFactor * 3
      ),
      lerp(
        this.pixi.worldMap.pivot.y, player.pixiObj.y,
        this.game.config.lerpFactor * 3
      )
    )
    // this.pixi.worldMap.pivot.set(player.pixiObj.x, player.pixiObj.y)
  } // pixiUpdate
  gridToPX ({ x, y }) {
    return { x: x * 300, y: y * 300 }
    /* const spaceX = 500
    const spaceY = 240
    return {
      x: x * spaceX + (y % 2 ? spaceX / 2 : 0),
      y: y * spaceY
    }/**/
  }
  offScreen (obj, bound) {
    if (bound === undefined) bound = 0
    const p = obj.toGlobal({ x: 0, y: 0 })
    if (p.x < -bound || p.x > this.pixiApp.screen.width + bound ||
        p.y < -bound || p.y > this.pixiApp.screen.height + bound) {
      return p
    }
    return false
  }
}

PIXI.Graphics.prototype.drawPoly = function drawPoly (x, y, radiusX, radiusY, sides) {
  if (radiusY === undefined) {
    radiusY = radiusX
  }
  sides = sides || 6
  const angInc = 2 * Math.PI / sides

  let curAngle = angInc
  let px = x + radiusX * Math.cos(curAngle)
  let py = y + radiusY * Math.sin(curAngle)

  // gr.drawShape(x, y, 6, radiusX);
  // let sides = 8
  if (!this.filling) {
    sides++
  }

  const points = [new PIXI.Point(px, py)]
  // this.moveTo(px, py)
  for (let i = 0; i < sides; i++) {
    curAngle += angInc
    let px = x + radiusX * Math.cos(curAngle)
    let py = y + radiusY * Math.sin(curAngle)
    points.push(new PIXI.Point(px, py))
    // this.lineTo(px, py)
  }
  this.drawPolygon(points)

  return this
}

export default RenderSystem
